const noop = () => {}

export const configureConsoleForEnv = () => {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  console.log = noop
  console.info = noop
  console.warn = noop
  console.error = noop
}
